import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var everydayIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 7.75c-1.9 0-3.43-2.23-3.43-4.07a3.43 3.43 0 0 1 6.86 0c0 1.84-1.53 4.07-3.43 4.07Zm0-6a1.94 1.94 0 0 0-1.93 1.93c0 1.1.95 2.57 1.93 2.57s1.93-1.47 1.93-2.57A1.94 1.94 0 0 0 12 1.75Zm7.41 21.57a.76.76 0 0 0-.1-.79c-4.68-5.73-3.81-11.18-3.45-12.67a19.49 19.49 0 0 0 7-3.61A1 1 0 0 0 23 4.78l-.31-.32a18.21 18.21 0 0 1-7.59 4 .76.76 0 0 0-.54.5c-.09.27-2.08 6.47 2.67 13.25h-1.9c-.65-.71-2.58-3-2.58-5.25a.75.75 0 0 0-1.5 0c0 2.22-1.93 4.54-2.58 5.25H6.78C11.53 15.47 9.54 9.27 9.45 9a.76.76 0 0 0-.54-.5 18.17 18.17 0 0 1-7.59-4L1 4.78a1 1 0 0 0 .1 1.47 19.49 19.49 0 0 0 7 3.61c.36 1.49 1.23 6.94-3.45 12.67a.76.76 0 0 0-.1.79.76.76 0 0 0 .68.43H9a.75.75 0 0 0 .53-.22A13.73 13.73 0 0 0 12 20a13.73 13.73 0 0 0 2.47 3.53.75.75 0 0 0 .53.22h3.73a.76.76 0 0 0 .68-.43Z",
  fill: "currentColor"
}));

export { everydayIcon as default };
//# sourceMappingURL=everydayIcon.js.map
